"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var SvgLockStrikethrough = function (props) { return (React.createElement("svg", __assign({ "data-testid": "ICON_LOCK-STRIKETHROUGH", width: "1em", height: "1em", viewBox: "0 0 16 17" }, props),
    React.createElement("path", { d: "M13 5.764V5A5 5 0 0 0 3 5v1.308a18.28 18.28 0 0 0-.802.13A1.472 1.472 0 0 0 1 7.89v4.802l2-1.155V8.33C3.888 8.19 5.555 8 8 8c.388 0 .756.005 1.104.013L13 5.763ZM11 6.1V5a3 3 0 0 0-6 0v1.101C5.838 6.041 6.838 6 8 6s2.162.041 3 .101ZM1 13.844v.002l-.5.29a1 1 0 1 0 1 1.731l.577-.333c.04.011.08.02.121.028C3.012 15.714 4.947 16 8 16c3.054 0 4.988-.286 5.802-.438A1.472 1.472 0 0 0 15 14.11V8.073l.496-.287a1 1 0 0 0-1-1.732l-.063.037a.429.429 0 0 1-.017.01l-13.37 7.72a.485.485 0 0 1-.046.023ZM8 14c-1.217 0-2.24-.047-3.072-.112L13 9.228v4.443c-.887.138-2.554.329-5 .329Z" }))); };
exports.default = SvgLockStrikethrough;
